const defaultUserState = {
	user: {},
	tos: false,
	branches: [],
	inviteUser: {},
	authModal: false,
	twoFactorModal: false,
	billing: { activeUsers: 0, invitedUsers: 0 },
	agencyUsers: ['loading'],
	agencyHash: ['loading'],
	updateRole: { role: '', branchId: '', managerAgencyUserId: '' },
	agency: { id: '', enforce2FA: false },
	sessionTTL: 0,
};

const CLEAR_STORE = 'CLEAR_STORE';
const SET_USER = 'SET_USER';
const SET_AGENCY = 'SET_AGENCY';
const SET_AGENCY_USER = 'SET_AGENCY_USER';
const SET_AGENCY_PENDING = 'SET_AGENCY_PENDING';
const SET_AGENCY_FULFILLED = 'SET_AGENCY_FULFILLED';
const SET_AGENCY_USERS = 'SET_AGENCY_USERS';
const SET_AGENCY_HASH = 'SET_AGENCY_HASH';
const SET_AGENCY_HASH_PENDING = 'SET_AGENCY_HASH_PENDING';
const SET_AGENCY_HASH_FULFILLED = 'SET_AGENCY_HASH_FULFILLED';
const SET_AGENCY_LOADED = 'SET_AGENCY_LOADED';
const SET_BRANCH_LIST = 'SET_BRANCH_LIST';
const SET_BRANCH_HASH = 'SET_BRANCH_HASH';
const SET_BRANCHES = 'SET_BRANCHES';
const SET_INVITE_USER = 'SET_INVITE_USER';
const SET_2FA_MODAL = 'SET_2FA_MODAL';
const SET_TWO_FACTOR_MODAL = 'SET_TWO_FACTOR_MODAL';
const SET_UPDATE_ROLE = 'SET_UPDATE_ROLE';
const SET_UPDATE_SESSIONTTL = 'SET_UPDATE_SESSIONTTL';

export default function userReducer(state = defaultUserState, action) {
	switch (action.type) {
		case CLEAR_STORE:
			return { ...defaultUserState };
		case SET_USER:
			return { ...state, user: action.payload };
		case SET_AGENCY_PENDING:
			return { ...state, agency: {} };
		case SET_AGENCY_FULFILLED:
			return { ...state, agency: action.payload };
		case SET_AGENCY:
			return {
				...state,
				agency: action.payload,
				sessionTTL: action.payload.enforceSessionTTLInSeconds,
			};

		case SET_AGENCY_USER: {
			const newList = { ...state.agencyUsers };
			const newHash = { ...state.agencyHash };
			newHash[action.payload?.id] = action.payload;
			const index = newList.findIndex((val) => val.id === action.payload?.id);
			if (index >= 0) {
				newList[index] = action.payload;
			}
			return {
				...state,
				agencyUsers: newList,
				agencyHash: newHash,
			};
		}
		case SET_AGENCY_USERS:
			const activeUsers = action.payload.filter(
				(user) => user.status === 'active'
			).length;
			const invitedUsers = action.payload.filter(
				(user) => user.status === 'invited'
			).length;
			return {
				...state,
				agencyUsers: action.payload,
				billing: {
					...state.billing,
					activeUsers: activeUsers,
					invitedUsers: invitedUsers,
				},
			};
		case SET_AGENCY_HASH_PENDING:
			return { ...state, agencyHash: {} };
		case SET_AGENCY_HASH_FULFILLED:
			return { ...state, agencyHash: action.payload };
		case SET_AGENCY_HASH:
			return { ...state, agencyHash: action.payload };
		case SET_AGENCY_LOADED:
			return { ...state, agencyLoaded: action.payload };
		case SET_BRANCH_LIST:
			return { ...state, branchList: action.payload };
		case SET_BRANCH_HASH:
			return { ...state, branchHash: action.payload };
		case SET_BRANCHES:
			return { ...state, branches: action.payload };
		case SET_INVITE_USER:
			return { ...state, inviteUser: action.payload };
		case SET_2FA_MODAL:
			return { ...state, authModal: action.payload };
		case SET_TWO_FACTOR_MODAL:
			return { ...state, twoFactorModal: action.payload };
		case SET_UPDATE_ROLE:
			return {
				...state,
				updateRole: action.payload,
			};
		case SET_UPDATE_SESSIONTTL:
			return {
				...state,
				sessionTTL: action.payload,
			};
		default:
			return state;
	}
}

export function setUser(user) {
	return {
		type: SET_USER,
		payload: user,
	};
}

export function setInviteUser(user) {
	return {
		type: SET_INVITE_USER,
		payload: user,
	};
}

export function setAgency(agency) {
	return {
		type: SET_AGENCY,
		payload: agency,
	};
}

export function setAgencyUser(user) {
	return {
		type: SET_AGENCY_USER,
		payload: user,
	};
}

export function setAgencyUsers(agency) {
	return {
		type: SET_AGENCY_USERS,
		payload: agency,
	};
}

export function setAgencyHash(hash) {
	return {
		type: SET_AGENCY_HASH,
		payload: hash,
	};
}

export function setAgencyLoaded(bool) {
	return {
		type: SET_AGENCY_LOADED,
		payload: bool,
	};
}

export function setBranchList(list) {
	return {
		type: SET_BRANCH_LIST,
		payload: list,
	};
}

export function setBranchHash(hash) {
	return {
		type: SET_BRANCH_HASH,
		payload: hash,
	};
}

export function setBranches(list) {
	return {
		type: SET_BRANCHES,
		payload: list,
	};
}

export function set2faModal(modal) {
	return {
		type: SET_2FA_MODAL,
		payload: modal,
	};
}

export function setTwoFactorModal(modal) {
	return {
		type: SET_TWO_FACTOR_MODAL,
		payload: modal,
	};
}

export function setUpdateRole(info) {
	return {
		type: SET_UPDATE_ROLE,
		payload: info,
	};
}

export function setUpdateSessionTTL(time) {
	return {
		type: SET_UPDATE_SESSIONTTL,
		payload: time,
	};
}
